import { render } from "./PrintTable.vue?vue&type=template&id=06ef6398"
import script from "./PrintTable.vue?vue&type=script&lang=js"
export * from "./PrintTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__